import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

export type PreviewStatusPopupVariant = "expired" | "empty";

@Component({
  selector: "app-preview-status-popup",
  templateUrl: "./preview-status-popup.component.html",
  styleUrls: ["./preview-status-popup.component.scss"],
})
export class PreviewStatusPopupComponent {
  @Input() variant: PreviewStatusPopupVariant = "expired";
  @Input() title = "";
  @Input() description = "";
  @Input() showBackButton = false;
  @Input() showRenewButton = false;
  @Input() showAlreadyPaidButton = false;

  constructor(public activeModal: NgbActiveModal) {}

  onGoBack(): void {
    this.activeModal.close("go-back");
  }

  onRenew(): void {
    this.activeModal.close("renew");
  }

  onAlreadyPaid(): void {
    this.activeModal.close("already-paid");
  }
}
